import React from 'react';
import Dialog from 'epn-ui/umd/dist/components/Dialog';
import TooltipPro from 'epn-ui/umd/dist/components/TooltipPro';
import Button from 'epn-ui/umd/dist/components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy';
import useI18n from '@i18n';
import { IModalFullDescription, IModalFullDescriptionHeader } from '@pages/coupons/interfaces';
import BaseSemanticLink from '@base/BaseSemanticLink';

const ModalHeader: React.FC<IModalFullDescriptionHeader> = ({
    promocode,
    logo,
    id,
    title,
    onCopyPromocode,
}) => (
    <>
        <div className="flex flex-col items-center flex-shrink-0 w-full gap-[26px] xs:flex-row p-[8px] xs:p-[16px] sm:mr-4 sm:mb-0 md:mr-6 lg:mr-10">
            <img className="object-cover h-10" src={logo} alt="coupon company logo" />

            {promocode && (
                <p className="flex-row items-center justify-center hidden px-2 py-2 text-center truncate border border-dashed  rounded-[4px] center xs:flex text-blueGray-600 h-[40px] border-blueGray-300 gap-[8px] xs:px-5 xs:w-full h-[fit-content] text-blueGray-800">
                    <button
                        type="button"
                        className="bg-transparent"
                        onClick={() => {
                            onCopyPromocode(promocode.toString());
                        }}
                    >
                        <FontAwesomeIcon icon={faCopy} />
                    </button>

                    <TooltipPro title={promocode} placement="top">
                        <p className="truncate text-blueGray-600">{promocode}</p>
                    </TooltipPro>
                </p>
            )}

            {promocode && (
                <p className="flex flex-row items-center justify-center w-full px-2 py-2 text-center truncate border border-dashed center xs:hidden text-blueGray-600 h-[40px] border-blueGray-300 gap-[8px] xs:px-5 xs:w-full">
                    <FontAwesomeIcon icon={faCopy} />
                    <button
                        type="button"
                        className="truncate text-blueGray-600 rounded-[6px]"
                        onClick={() => {
                            onCopyPromocode(promocode.toString());
                        }}
                    >
                        {promocode}
                    </button>
                </p>
            )}
        </div>
        <h3
            id={`CouponsPageCouponDiscount${id}`}
            className="mt-3 font-medium text-blueGray-800 text-sub p-[8px] xs:p-[16px] "
        >
            {title}
        </h3>
    </>
);

const ModalFullDescription: React.FC<IModalFullDescription> = ({
    onClose,
    coupon,
    getCouponLink,
    onCopyPromocode,
}) => {
    const { id, logo, promocode, title, description, offerId, url } = coupon;
    const { t } = useI18n('Coupons');
    const { t: tCommon } = useI18n('Common');

    return (
        <Dialog
            onCancel={onClose}
            open
            title={
                <ModalHeader
                    promocode={promocode}
                    onCopyPromocode={onCopyPromocode}
                    logo={logo}
                    id={id}
                    title={title}
                />
            }
            size="lg"
        >
            <div className="p-[8px] xs-[16px]">
                <p className="relative z-0 w-full mb-10">{description}</p>
                <div className="flex flex-col w-full gap-[8px] xs:gap-[16px] sm:gap-[24px] xs:flex-row">
                    <Button
                        id={`CouponsPageCouponGetLinkButton${id}`}
                        type="default"
                        className="sm:w-1/2 xs:w-full xs:max-w-full xs:flex-grow sm:flex-shrink"
                        onClick={() => getCouponLink(offerId, url, promocode)}
                    >
                        {tCommon('Get link')}
                    </Button>

                    <BaseSemanticLink
                        className="px-2 py-2 text-center text-white sm:w-1/2 xs:w-full xs:max-w-full xs:flex-grow sm:flex-shrink xs:px-3 bg-brandColor hover:opacity-80 hover:text-white rounded-[6px]"
                        type="primary"
                        to={url}
                    >
                        {t('Go to the shop')}
                    </BaseSemanticLink>
                </div>
            </div>
        </Dialog>
    );
};

export default ModalFullDescription;
